import React from "react";
import Select, {SingleValue, StylesConfig} from "react-select";

import {Option} from "../DropdownHelper";

import styles from "./StaticDropdown.module.scss";

type DropdownProps = {
  id?: string;
  classname?: string;
  selectClassname?: string;
  options: Option[];
  title: SingleValue<Option> | null;
  onChange: (value: SingleValue<Option>) => void;
  indicator?: boolean;
};

export default function StaticDropdown({
  id = "",
  classname = "",
  selectClassname = "",
  options,
  title,
  onChange,
  indicator = false,
}: DropdownProps) {
  const selectComponents = indicator
    ? {IndicatorSeparator: () => null}
    : {
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      };

  const isMobile = window.innerWidth < 768;

  const customStyles: StylesConfig<Option, boolean> = {
    singleValue: (provided) => ({
      ...provided,
      color: "#006a7c",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "#141414",
      backgroundColor: state.isSelected
        ? "#f7f7f7"
        : state.isFocused
          ? "#f7f7f7"
          : "#ffffff",
      margin: "0px",
      fontWeight: "400",
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      border: "none",
      fontWeight: "400",
      backgroundColor: state.isFocused ? "#f7f7f7" : "transparent",
      "&:hover": {
        backgroundColor: "#f7f7f7",
      },
      boxShadow: "none",
      "&:focus": {
        boxShadow: "none",
      },
      cursor: "pointer",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0px",
      borderRadius: "5px",
      maxHeight: "200px",
      scrollbarColor: "#f1f1f1 transparent",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "5px",
    }),
  };

  return (
    <div className={`${styles.container} ${classname}`}>
      <Select
        id={id}
        className={`${styles.customSelect} ${selectClassname}`}
        components={selectComponents}
        value={title}
        options={options}
        onChange={(selected) => {
          onChange(selected as SingleValue<Option>);
        }}
        styles={customStyles}
      />
    </div>
  );
}
